import { ModelBase } from "@singularsystems/neo-core";

export default class ClientWithWoodpeckerCompanyId extends ModelBase {
  public woodpeckerCompanyId: number = 0;

  public woodpeckerClientName: string = "";
}